<template>
    <div class="height">
        <div class="web">
            <div class="new-bg" :class="`fen${page} ${page==totalPages?'last':''}`" v-if="info">
                <vue-header title="健康报告" :report="true" :fixed="true" :notoken="noToken" :isLoginFun="isLoginFun" />
                <div class="erect">
                    <div class="tips">郑重提醒：本报告不作医学诊断及购药依据之用！</div>
                    <template v-for="(pageConfig, pageIndex) in pageList">
                        <div
                            class="new-box"
                            :class="`y${pageIndex + 1}`"
                            :key="pageIndex"
                            v-if="isPageVisible(pageConfig)"
                        >
                            <component
                                v-for="moduleName in pageConfig.modules"
                                :key="moduleName"
                                :is="getComponentName(moduleName)"
                                :show-modules="showModules"
                            />
                        </div>
                    </template>
                </div>
                <div class="fen-page">
                    <div class="s-page">
                        <div class="prev" @click="()=>pageFun({ page:page, add:-1 })">上一页</div>
                    </div>
                    <div class="s-page">
                        <div class="next" @click="()=>pageFun({ page:page, add:1 })">下一页</div>
                    </div>
                </div>
                <div class="bottom-btns" v-if="showBottomBtns">
                    <div class="btn consult" @click="consultFun">我要咨询</div>
                    <div class="btn home" @click="backHomeFun">返回首页</div>
                </div>
            </div>
            <div v-if="loading" class="load-ur flex flex-x flex-y">
                <van-loading size="60" text-color="#07B49A"/>
            </div>
            <div v-if="login">
                <vue-popup :showFun="loginFun" :callback="refrFun" :token="this.$route.params.id" />
            </div>
            <div v-if="history">
                <vue-popup :showFun="noLoginFun" :url="isLogin" :login="true" :birthday="info.birthday" :token="this.$route.params.id" :text="this.isLogin=='report'?'注册/登录':'搜索报告'" />
            </div>
            <div v-if="prescribe">
                <vue-popup :showFun="prescribeFun" :callback="presFun" :token="this.$route.params.id" :prescribe="true" :skipFun="skipFun" />
            </div>
            <div class="loading black flex flex-x flex-y" v-if="send" @click="sendStateFun('send')">
                <div class="loading-box" v-on:click.stop>
                    <div class="load-bac load-wx">
                        <div class="flex">
                            <div class="flex-1"></div>
                            <van-icon name="cross" size="20"  @click="sendStateFun('send')"/>
                        </div>
                        <img src="../../../images/icon.png"/>
                        <p>1、先识别手机上的二维码, 如果是公众号请关注。</p>
                        <p>2、再点击"发送报告"</p>
                        <div class="send-box" v-if="module_list.length>0">
                            <div class="send-moule">选择发送的模块</div>
                                <van-checkbox-group v-model="moduleName" direction="horizontal">
                                    <div class="send-checkbox" v-for="(items, index) in module_list" :key="index">
                                        <van-checkbox  shape="square" :name="items.id" checked-color="#07b49a">{{items.module_name}}</van-checkbox>
                                    </div>
                                </van-checkbox-group>
                        </div>
                        <div class="again" @click="sendFun" v-if="module_list.length==0 || module_name.length>0">发送报告</div>
                        <div class="again dim" v-else>发送报告</div>
                    </div>
                </div>
            </div>
            <div class="loading black flex flex-x flex-y" v-if="doctor" @click="sendStateFun('doctor')">
                <div class="overlay" v-on:click.stop>
                    <div v-if="erweim()">
                        <div class="overlay-whith" >
                            <img :src="erweim()"/>
                        </div>
                        <div class="overlay-text">医生扫码</div>
                        <div class="overlay-text size-min">医生用微信扫码为用户开方诊断</div>
                    </div>
                    <div v-else class="overlay-top">
                        <div class="overlay-text">请联系管理人员绑定公众号</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="print">
            <vue-print :user="user" :info="info" :MBItext="MBItext(info.bmi)" :module="module"/>
        </div>
    </div>
</template>
<script>
import vueHeader from '@/components/header';
import vuePrint from '@/views/report/print';
import { mapState, mapActions, mapMutations } from "vuex";
import { isInWechatMPO , makecode } from "@/utils";
import vuePopup from "@/components/popup";
import domain from "@/utils/config";
import modules from './module';
import { canShowModule, MBItext, getPageConfig, MODULE_COMPONENT_MAP } from './module/helpers';

export default {
    name: 'report',
    data(){
        return{
            bool:false,
            noToken:false,
            isLogin:'reportList',
            showBottomBtns:!!(sessionStorage.getItem('new_card_biaoshi') || this.$route.query.new_card_biaoshi)
        }
    },
    components:{
        vueHeader,
        vuePopup,
        vuePrint,
        ...modules
    },
    created:function(){
        let returns = sessionStorage.getItem('return');
        if(!this.$route.query.return&&returns=='2'){
            this.noToken = true;
        }

        if(window.xiekangAndroidInterface){
            this.noToken = true;
        }
        
        if(this.$route.query.token && !sessionStorage.token){
            sessionStorage.setItem('token',this.$route.query.token);
        }

         //返回地址：完整链接直接存；pages-VIP-tizhi-index 格式转换成 pages/VIP/tizhi/index
        if(this.$route.query.wx_return){
            let wxReturn = this.$route.query.wx_return;
            if(!/^https?:\/\//i.test(wxReturn)){
                wxReturn = wxReturn.replace(/-/g,'/');
            }
            sessionStorage.setItem('wx_return',wxReturn);
        }
        
        //打印页面
        window.addEventListener('message', function(event) {
            if(event.data=='printFun'){
                window.print();
            }
        });

        this.axiosData({
            report_token:this.$route.params.id
        })
    },
    destroyed: function () {
        this.closeFun();
    },
    computed: {
        totalPages() {
            return getPageConfig().length;
        },
        moduleName:{
            get() { return this.$store.state.report.module_name },
            set(val){
                this.changeFun({
                    key:'module_name',
                    value:val
                });
            }
        },
        pageList() {
            return getPageConfig();
        },
        ...mapState ("report", ["info","module","loading","login","send","page","user","module_list","module_name","prescribe","doctor",'history','showModules']),
    },
    methods: {
        MBItext,

        // 是否显示某模块
        canShow(name) {
            return canShowModule(name, this.showModules);
        },

        // 数组中任意一个模块可显示则返回 true（用于页级别的容器判断）
        anyShow(names) {
            if (!Array.isArray(names)) return false;
            return names.some((n) => this.canShow(n));
        },

        getComponentName(moduleName) {
            return MODULE_COMPONENT_MAP[moduleName];
        },

        // 根据 MODULE_CONFIG 的 modules + validateKeys 判断整页是否可见
        isPageVisible(pageConfig) {
            if (!this.anyShow(pageConfig.modules)) return false;
            if (pageConfig.validateKeys && pageConfig.validateKeys.length > 0) {
                return pageConfig.validateKeys.every(key => this.info && this.info[key]);
            }
            return true;
        },

        isLoginFun(bool){
            this.isLogin = bool?'report':'reportList';
        },

        //二维码
        erweim(){
            let equipment = JSON.parse(sessionStorage.getItem('equipment'));
            if(equipment){
                let url;
                if(this.bool){
                    url = `https://${equipment.appid}.device${domain}/addUser/${this.$route.params.id}`;
                }else{
                    url = `https://${equipment.appid}.device${domain}/prescribeQuestion/${this.$route.params.id}`;
                }
                return makecode(url);
            }else{
                return false;
            }
        },

        href(item){
            if (isInWechatMPO()) {
                let wx = window.wx;
                wx.miniProgram.navigateTo({url:item});
                return;
            }else{
                window.location.href = item;
            }
        },

        //跳转小程序页面（isTab 为 true 时用 switchTab，否则用 navigateTo）
        jumpMiniPage(url, isTab){
            let doJump = () => {
                if(!window.wx || !window.wx.miniProgram){
                    this.$toast('跳转失败：当前环境不支持小程序跳转');
                    return;
                }
                let jump = isTab ? window.wx.miniProgram.switchTab : window.wx.miniProgram.navigateTo;
                if(!jump){
                    this.$toast('跳转失败：当前环境不支持小程序跳转');
                    return;
                }
                try{
                    jump.call(window.wx.miniProgram, {
                        url,
                        fail: (err) => {
                            console.log('jumpMiniPage fail', err);
                            this.$toast('跳转失败：' + (err && err.errMsg ? err.errMsg : JSON.stringify(err)));
                        }
                    });
                }catch(e){
                    this.$toast('跳转异常：' + e.message);
                }
            };
            if(window.wx && window.wx.miniProgram){
                doJump();
                return;
            }
            //临时加载微信 jweixin js
            let script = document.createElement('script');
            script.src = 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js';
            script.onload = doJump;
            script.onerror = () => {
                this.$toast('跳转失败：微信 JSSDK 加载失败');
            };
            document.head.appendChild(script);
        },

        //返回首页（逻辑同 header 的 wxReturnJump：小程序 switchTab，公众号跳链接）
        backHomeFun(){
            let wxReturn = sessionStorage.getItem('wx_return');
            if(!wxReturn){
                return;
            }
            //小程序环境
            if(navigator.userAgent.match(/miniprogram/i) || window.wxjs_environment == "miniprogram"){
                if(window.wx && window.wx.miniProgram){
                    try{
                        window.wx.miniProgram.switchTab({
                            url:'/' + wxReturn,
                            fail(err){
                                console.log('switchTab fail', err);
                            }
                        });
                    }catch(e){
                        console.log('switchTab error', e);
                    }
                }
                return;
            }
            //公众号（微信浏览器）
            if(navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1){
                window.location.href = wxReturn;
            }
        },

        //我要咨询（小程序 navigateTo 带报告 token；公众号把 wx_return 的路由换成 goConsult，域名不变）
        consultFun(){
            //小程序环境
            if(navigator.userAgent.match(/miniprogram/i) || window.wxjs_environment == "miniprogram"){
                this.jumpMiniPage(`/pages/VIP/goConsult/index?report_token=${this.$route.params.id}`, false);
                return;
            }
            //公众号（微信浏览器）
            if(navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1){
                let wxReturn = sessionStorage.getItem('wx_return');
                if(wxReturn){
                    let origin = (wxReturn.match(/^https?:\/\/[^/]+/i) || [''])[0];
                    if(origin){
                        //tz-baoxian H5 为 hash 路由模式，需带 /#/，并带上报告 token
                        window.location.href = origin + '/goConsult?report_token=' + this.$route.params.id;
                        return;
                    }
                }
                this.$toast('跳转失败：缺少返回地址');
            }
        },

        //小程序分割数据
        GetRequest(url){
            var theRequest = {};
            if (url.indexOf("?") != -1) {
                var str = url.split("?");
                theRequest.path = str[0];
                var strs = str[1].split("&");
                for(var i = 0; i < strs.length; i ++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        },
        //登录
        loginFun(){
            this.changeFun({
                key:'login',
                value:false
            })
        },
        noLoginFun(){
            this.changeFun({
                key:'history',
                value:false
            })
        },
        //开方
        prescribeFun(){
            this.changeFun({
                key:'prescribe',
                value:false
            })
        },
        //发送报告登录完成的后续工作
        refrFun(){
            this.bool = false;
            this.axiosData({
                report_token:this.$route.params.id
            });
            this.axiosUser({
                report_token:this.$route.params.id
            });
            this.changeFun({key:'login',value:false});
            this.changeFun({key:'send',value:true});
            let equipment = JSON.parse(sessionStorage.getItem('equipment'));
            if(equipment && equipment.send_template_select==1){
                this.sendMain({
                    equipment_code:equipment.equipment_code
                });
            }
        },
        //历史记录登录完成后的后续公众
        historyFun(){
            this.$router.push({
                name:'reportList'
            });
        },
        //登录完成后开方后续工作
        presFun(){
            this.changeFun({key:'prescribe',value:false});
            this.changeFun({key:'doctor',value:true});
        },
        //跳过
        skipFun(bool){
            this.changeFun({key:'prescribe',value:false});
            this.changeFun({key:'doctor',value:true});
            this.bool = bool;
        },
        //关闭模版
        sendStateFun(key){
            this.changeFun({
                key:key,
                value:false
            })
        },
        //发送模版消息
        sendFun(){
          if(sessionStorage.token){
            this.axiosSend({
                data:{
                    token:this.$route.params.id
                }
            })
          }
        },
        //翻页
        pageFun(val) {
            this.pageChange(val);
            this.$nextTick(() => {
                window.scrollTo(0, 0);
                if (document.documentElement) {
                    document.documentElement.scrollTop = 0;
                }
                if (document.body) {
                    document.body.scrollTop = 0;
                }
                const wrap = this.$el && this.$el.querySelector
                    ? this.$el.querySelector('.new-bg')
                    : null;
                if (wrap) {
                    wrap.scrollTop = 0;
                }
            });
        },
        ...mapMutations ("report", ["changeFun","pageChange","closeFun"]),
        ...mapActions ("report", ["axiosData","axiosSend","axiosUser","sendMain"])
    }
}
</script>
<style lang="scss" scoped>
  @import './report';
</style>
<style lang="scss">
  @import './module/common';
</style>
